import React, { useState } from "react";
import { ORG } from "../data/costant";
import { Link } from "react-router-dom";
import Alert from "../utils/Alert";
import {
  BsHouseDoor,
  BsEnvelope,
  BsPhone,
  BsWatch,
  BsInfoCircle,
  BsBook,
  BsTelephone,
} from "react-icons/bs";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const validateEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Email is required.");
      return;
    }
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    setTimeout(() => {
      Alert.success("Subscription request sent successfully!");
    }, 5000);
  };

  return (
    <footer className="footer-area section_gap" style={{ padding: "50px" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6 single-footer-widget">
            <h4>{ORG.name}</h4>
            <ul style={{ color: "#fdc632" }}>
              <li>
                <BsEnvelope style={{ fontSize: "16px", marginRight: "5px" }} />{" "}
                <span>{ORG.email}</span>
              </li>
              <li>
                <BsPhone style={{ fontSize: "16px", marginRight: "5px" }} />
                <span>{ORG.mobile}</span>
              </li>
              <li>
                <BsWatch style={{ fontSize: "16px", marginRight: "5px" }} />{" "}
                <span>{ORG.hours}</span>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 single-footer-widget">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link style={{ color: "#fdc632" }} to={"/"}>
                  <BsHouseDoor style={{ fontSize: "16px" }} /> Home
                </Link>
              </li>
              <li>
                <Link style={{ color: "#fdc632" }} to="/about">
                  <BsInfoCircle size={18} style={{ marginRight: 5 }} /> About
                </Link>
              </li>
              <li>
                <Link style={{ color: "#fdc632" }} to="/course">
                  <BsBook size={18} style={{ marginRight: 5 }} /> Course
                </Link>
              </li>
              <li>
                <Link style={{ color: "#fdc632" }} to="/contact">
                  <BsTelephone size={18} style={{ marginRight: 5 }} /> Contact
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 single-footer-widget">
            <h4>Policies</h4>
            <ul style={{ color: "#fdc632" }}>
              <li>
                <Link style={{ color: "#fdc632" }} to={"/privacy"}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link style={{ color: "#fdc632" }} to={"/terms"}>
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link style={{ color: "#fdc632" }} to={"/refund"}>
                  Refund & Cancellation Policy
                </Link>
              </li>
              <li>
                <Link style={{ color: "#fdc632" }} to={"/shipping"}>
                  Shipping Policy
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 single-footer-widget">
            <h4>Newsletter</h4>
            <p style={{ color: "#fdc632" }}>
              You can trust us. We only send promo offers.
            </p>
            <div className="form-wrap" id="mc_embed_signup">
              <form onSubmit={handleSubmit} className="form-inline">
                <input
                  className="form-control"
                  name="email"
                  placeholder="Your Email Address"
                  required=""
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className="click-btn btn btn-default">
                  <span>subscribe</span>
                </button>
                <div style={{ position: "absolute", left: "-5000px" }}>
                  <input
                    name="b_36c4fd991d266f23781ded980_aefe40901a"
                    tabIndex="-1"
                    type="text"
                  />
                </div>
                {error && (
                  <div style={{ color: "red", marginTop: "5px" }}>{error}</div>
                )}
                <div className="info"></div>
              </form>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-lg-12 text-center">
            <p style={{ color: "#fdc632", marginTop: "20px" }}>
              Copyright {new Date().getFullYear()} Onelife Education Society.
              All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
